module.exports = __webpack_public_path__ + "img/green-logo-large.bcb87717.png";